






































import Tooltip from "@/components/utility/tooltip.vue";
import { ISignDocument } from "@/models/sign-document.entity";
import { Component, Prop, Vue } from "vue-property-decorator";
import { isSignatureToken } from "@/lib/signature-token.utils";

@Component({
  components: {
    Tooltip
  },
  filters: {}
})
export default class SignFormSignaturePageListSheet extends Vue {
  @Prop()
  index!: number;

  @Prop()
  currentPageNumber!: number;

  @Prop()
  document!: ISignDocument;

  @Prop()
  page!: any;

  countMissingTokens(page: number) {
    return this.document.tokens[page].filter(
      token => !isSignatureToken(token.token) && !token.value && token.isEditable
    ).length;
  }

  countMissingRequiredTokens(page: number) {
    return this.document.tokens[page].filter(
      token => !isSignatureToken(token.token) && !token.value && token.isEditable && token.isRequired
    ).length;
  }

  countSignatureTokens(page: number) {
    return this.document.tokens[page].filter(token => isSignatureToken(token.token)).length;
  }
}
